import { BaseTimelineChartModel } from './_base_timeline_chart_model';

export class MultilineChartModel extends BaseTimelineChartModel {
  _getMaxYValue () {
    return Math.max(...this.rawData.map(elem => Math.max(...elem.data.map(d => d.value))));
  }
}
